// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3-E27","col":"Table_col__1b9C8","fulfillmentStatus":"Table_fulfillmentStatus__4KHvj","emailCol":"Table_emailCol__izdSo"};